<template>
  <div class="form-title-wrapper">
    <div class="form-title-icon" />
    <div class="form-title-text">
{{ title }}
</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="less" scoped>
.form-title-wrapper {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: rgba(0, 1, 10, 0.93);
}

.form-title-icon {
  width: 2px;
  height: 16px;
  margin-right: 4px;
  background: #4A70FF;
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
  border-bottom-left-radius: 9px;
  border-bottom-right-radius: 9px;
}
.form-title-text {
  font-weight: 500;
  line-height: 17px;
}
</style>
